import { ErrorImg } from "@punchup/ui-common/components/common";

export default ErrorImg;
